import {
    SET_COMMENTS,
    SET_EDIT_COMMENT,
    SET_NEW_COMMENT,
    SET_DELETE_COMMENT,
    SET_DELETE_MULTI_COMMENT,
    SET_LIST_COMMENTS,
    SET_COMMENT,
    RESET_ITEMS_COMMENT,
    RESET_LIST_COMMENTS,
} from "redux/constants/Comments";

const initalAgreementState = {
    items: [],
    list: [],
    selected: {},
    loading: true,
};
const Comments = (state = initalAgreementState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_COMMENTS: {
            return { ...state, items: payload, loading: false };
        }
        case SET_LIST_COMMENTS: {
            return { ...state, list: payload };
        }
        case SET_COMMENT: {
            return { ...state, selected: payload };
        }
        case SET_NEW_COMMENT: {
            return { ...state, items: [payload, ...state.items] };
        }

        case SET_EDIT_COMMENT: {
            let list = [...state.items];

            try {
                let ind = list.findIndex((item) => item._id === payload._id);

                if (ind > -1) {
                    list[ind] = payload;
                }
            } catch (error) {}

            return { ...state, items: list };
        }

        case SET_DELETE_COMMENT: {
            let list = state.items.filter((item) => item._id !== payload);

            return { ...state, items: list };
        }

        case SET_DELETE_MULTI_COMMENT: {
            let arr = payload.split(",");
            let list = state.items.filter((item) => !arr.includes(item._id));

            return { ...state, items: list };
        }
        case RESET_LIST_COMMENTS: {
            return { ...state, list: [] };
        }

        case RESET_ITEMS_COMMENT: {
            return { ...state, items: [], loading: true };
        }

        default:
            return state;
    }
};

export default Comments;
